import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-dollar-icon',
  templateUrl: './shopping-dollar.component.html'
})
export class ShoppingDollarComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
